/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateSiteSectionRequestSiteSectionFromJSON, UpdateSiteSectionRequestSiteSectionToJSON } from './UpdateSiteSectionRequestSiteSection';
export function UpdateSiteSectionRequestFromJSON(json) {
    return UpdateSiteSectionRequestFromJSONTyped(json, false);
}
export function UpdateSiteSectionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        siteSection: !exists(json, 'site_section')
            ? undefined
            : UpdateSiteSectionRequestSiteSectionFromJSON(json['site_section'])
    };
}
export function UpdateSiteSectionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        site_section: UpdateSiteSectionRequestSiteSectionToJSON(value.siteSection)
    };
}
